import React from 'react';
import styled from "styled-components";
import { useNavigate } from 'react-router-dom';
import { PlatFormAccordionTitleProps } from '../types';

const PlatFormAccordionTitle: React.FC<PlatFormAccordionTitleProps> = ({ title, expandedItems, link,name='', text}) => {
  const navigate = useNavigate();

  const handleRedirect = () => {
    navigate(link);
  }

  return (
    <HeaderRow>
      <HeaderContent>
        <Title onClick={(e)=>e.stopPropagation()}>{title} <span>{expandedItems.includes('pricing') && text}</span></Title>
        {expandedItems.includes(name) && <EditButton  onClick={handleRedirect}>Edit</EditButton>}
      </HeaderContent>
    </HeaderRow>
  );
};

const Title = styled.span`
  font-family: SF Pro Display;
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
  letter-spacing: 0;
  vertical-align: middle;

    span{
     color:#00000080;
    }
`;

const EditButton = styled.button`
  width: 51px;
  height: 24px;
  border-radius: 100px;
  border:none;
  font-family: SF Pro Display;
  font-weight: 600;
  font-size: 13px;
  line-height: 18px;
  letter-spacing: 0;
`;

const HeaderRow = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
`;

const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export default PlatFormAccordionTitle;
